module.exports = __webpack_public_path__ + "media/images/teams/SASSUOLO-58d88be536d08a97eca835083c16b88c.png";